import {useLocation, useNavigate} from 'react-router-dom';
import { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import GlobalVar from './GlobalVar';

const ProdCard = ({prod, stateInfo, dispachInfo})=>{

    
    // [`${prod.cod_ref} |||| ${produtoAtual.tamanho} |||| ${produtoAtual.color}`] = {
    //     ref: prod.cod_ref,
    //     descricao: `${prod.descbasica.concat(" - ", prod.rev_nom)}${" . PAG.:"+ prod.pagina}`,
    //     preco: parseFloat(prod.produto_preco), //'R$ '+GlobalVar.converteFloat(parseFloat(prod.produto_preco)),
    //     tamanho: produtoAtual.tamanho,
    //     cor: produtoAtual.color,
    //     quantidade: produtoAtual.quantidade
    // }

    const urlImage = `https://apirevendedoratime.babita.com.br/images/${prod.ref}.jpg`

    const [bg, setBg] = useState('#FFF');
    
      useEffect(() => {
          //console.log("TESTE IMAGE")
        //   console.log(prod)
        const img = new Image();
        img.src = urlImage;
    
        img.onload = () => {
          setBg(`url('${urlImage}')`);
        };
    
        img.onerror = () => {
          setBg(`url('https://apifornecedores.babita.com.br/images/publicImages/ImagemNaoEncontrada.jpg')`);
        };
      }, [urlImage]);

    return <div className="prodCard">
        <div className="removerItem" onClick={()=>{
            const sacola = GlobalVar.destructObj(stateInfo.produtosSacola)
            delete sacola[`${prod.ref} |||| ${prod.tamanho} |||| ${prod.cor}`];
            dispachInfo({
                type: 'produtosSacola',
                value: sacola
                })
        }}></div>
        <div className="leftContent">
        <div className='fotoProd'
                                style={{background: `${bg} no-repeat center/contain`}}>
                                        <div className="botaoVoltar" onClick={()=>dispachInfo({type: 'telaAtual', value: 1})}></div>
                                </div>
        </div>
        <div className="rightContent">
            <div className="title">{prod.descricao}</div>
            <div className="referencia">{prod.ref}</div>
            <div className="corETamanho"><div className="corCirle" style={{'--color-hex': prod.cor === 'Cor da Foto' ? '#000000' : prod.hex }}></div><div className="text">{prod.cor === 'Cor da Foto' ? 'PRETO' : prod.cor.toUpperCase()}</div></div>
            <div className="quantidadeBtns">
                {/* <div className="quantidadeTotal" >{prod.quantidade}</div> */}
                <div className="title">UNI.:</div>
                <input
                    className="quantidadeTotal"
                    type="text" inputMode="numeric" pattern="[0-9]*"
                        value={parseInt(prod.quantidade)}
                        name="searchTerm"
                        onChange={(e) => {
                            const sacola = GlobalVar.destructObj(stateInfo.produtosSacola)
                            
                            const valor = parseInt(e.target.value, 10)
                            const valorTratado = Number.isNaN(valor) || valor < 0 ? 0 : valor
                            sacola[`${prod.ref} |||| ${prod.tamanho} |||| ${prod.cor}`].quantidade = valorTratado
                                dispachInfo({
                                type: 'produtosSacola',
                                value: sacola
                                })
                        }}
                        // onClick={toggle}
                    />
                {/* <div className="circleQtd" onClick={()=>{
                        // let quantidade = stateInfo.produtoPaginaSelectedInfo.quantidade
                        // dispachInfo({type: 'produtoPaginaSelectedInfo', value: {...GlobalVar.destructObj(stateInfo.produtoPaginaSelectedInfo), 
                        //     quantidade: quantidade+1}})
                    }}>
                </div> */}
            </div>
                <div className="bottomInfo">
                    <div className="tamanho">Tamanho: {prod.tamanho}</div>
                    <div className="preco">R$ {GlobalVar.converteFloat(parseFloat(prod.preco))}</div>
                </div>
        </div>
    </div>
}



const Sacola  = forwardRef(({ativaResp,showStyle, stateInfo, dispachInfo},ref)=>{

    const [usuario, setUsuario] = useState({nome: 'Usuario'});  // ObjetoUsuario 
    const navigate = useNavigate();

    const [showLateralSacola, setShowLateralSacola] = useState('inicial')


    const location = useLocation().pathname;

    useImperativeHandle(ref, (value) => ({
        // methods connected to `ref`
        setShowLateralSacola: (value) => {
            setShowLateralSacola(value)
        }
      }))

    useEffect(() => {
        if (showStyle) {
          // Importa dinamicamente quando necessário
            import('../../assets/css/sacola.css');
        }
      }, [showStyle]);
    
    useEffect(()=>{
        console.log(stateInfo.produtosSacola)
    },[stateInfo.produtosSacola])

    useEffect(() => {
    const { quantidadeTotal, valorTotal } =
        calcularTotaisProdutos(stateInfo.produtosSacola)
        dispachInfo({type: 'quantidadeTotalSacola', value: quantidadeTotal})
        dispachInfo({type: 'valorTotalSacola', value: valorTotal})
    }, [stateInfo.produtosSacola, showLateralSacola])


    return <>
    
            <div className={`sacolaBarraLateral  
            ${showLateralSacola === 'inicial' ? 'sacolaBarraLateralInicial' : showLateralSacola ? "mostraSacolaLateral" : "escondeSacolaLateral"}`}>
        


                <div className='menuCloseBtn' onClick={()=>setShowLateralSacola(false)}></div>
                

                <div className="midData">
                    {Object.keys(stateInfo.produtosSacola).map((key)=>{
                        const prod = stateInfo.produtosSacola[key]
                        return <ProdCard prod={prod} stateInfo={stateInfo} dispachInfo={dispachInfo}/>
                    })}

                </div>

                <div className="bottomData">
                    <div className="totais">
                        <div className="qtdeTotal">Qtde.: {stateInfo.quantidadeTotalSacola}</div>
                        <div className="vlrTotal">Total: R$ {GlobalVar.converteFloat(stateInfo.valorTotalSacola)}</div>
                    </div>
                    {Object.keys(stateInfo.produtosSacola).length > 0 ? 
                    <div className="finalizaPedido" onClick={()=>{
                        setShowLateralSacola(false)
                        dispachInfo({type: 'pedidoFinalizado', value: true})
                    }}>FINALIZAR COMPRA</div> :
                    <div className="finalizaPedido">SUA SACOLA ESTÁ VAZIA</div>} 
                </div>

            </div>
        </>
})

export default Sacola;


function calcularTotaisProdutos(produtosObj) {
    let quantidadeTotal = 0
    let valorTotal = 0
  
    Object.values(produtosObj || {}).forEach((item) => {
      const quantidade = Number(item.quantidade) || 0
  
      quantidadeTotal += quantidade
      valorTotal += Math.round(quantidade * item.preco *100)/100
    })
  
    return {
      quantidadeTotal,
      valorTotal: valorTotal.toFixed(2)
    }
  }
  